import { Language } from '../types';

export const LANGUAGES = [{
  value: Language.English,
  text: Language.English,
}, {
  value: Language.Russian,
  text: Language.Russian,
}];
